var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-page"},[_c('transition',{attrs:{"name":"pzz","mode":"out-in"}},[_c(_vm.componentId,{tag:"component",on:{"changeComponent":_vm.changeComponent}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }